<template>
    <div v-if="visible" class="fixed inset-0 z-[10000] bg-black flex items-center justify-center">
        <div class="relative w-full h-full max-w-[480px] overflow-hidden">
            <video
                ref="video"
                :src="src"
                class="absolute inset-0 w-full h-full object-cover transition-[filter] duration-300"
                :class="[playing ? '' : 'scale-110']"
                autoplay
                muted
                playsinline
                preload="auto"
                @click="toggle"
                @play="playing = true"
                @pause="playing = false"
                @ended="playing = false"
            ></video>

            <button class="absolute top-6 right-5 text-white bg-black/40 rounded-full w-8 h-8 flex items-center justify-center" @click="close">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
            </button>

            <button
                v-if="!playing"
                class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform w-14 h-14 rounded-full bg-black/40 flex items-center justify-center"
                @click="toggle"
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" class="w-7 h-7">
                    <path d="M6 4.5v15a1 1 0 0 0 1.5.86l12.5-7.5a1 1 0 0 0 0-1.72L7.5 3.64A1 1 0 0 0 6 4.5z" />
                </svg>
            </button>

            <div class="absolute bottom-0 inset-x-0 p-3 pb-8 flex gap-2">
                <a :href="demoUrl" target="_blank" class="flex-1 py-2 rounded-full bg-[#F08C00] text-[#1A1A2E] text-center text-sm font-medium">
                    Book a demo
                </a>
                <button class="flex-1 py-2 rounded-full bg-white text-[#1A1A2E] text-center text-sm font-medium" @click="close">
                    Go to site
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            visible: !localStorage.getItem('video_promo_modal_closed'),
            playing: false,
            src: '/video/movenpicklalezdurres.mp4',
            demoUrl: 'https://calendly.com/dgstay',
        };
    },
    mounted() {
        const video = this.$refs.video;
        if (video) {
            video.muted = true;
            video.play().catch(() => {});
        }
    },
    methods: {
        toggle() {
            const video = this.$refs.video;
            if (video.paused) {
                video.play();
                this.playing = true;
            } else {
                video.pause();
                this.playing = false;
            }
        },
        close() {
            if (this.$refs.video) this.$refs.video.pause();
            localStorage.setItem('video_promo_modal_closed', '1');
            this.visible = false;
        },
    },
};
</script>
